import { render } from "./ModalManageRouteRegion.vue?vue&type=template&id=0a5675b1&scoped=true"
import script from "./ModalManageRouteRegion.vue?vue&type=script&lang=js"
export * from "./ModalManageRouteRegion.vue?vue&type=script&lang=js"

import "./ModalManageRouteRegion.vue?vue&type=style&index=0&id=0a5675b1&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5675b1"]])

export default __exports__